import React, { forwardRef, ButtonHTMLAttributes } from "react";

import classnames from "classnames";

import { StyledGlobalAddButton } from "./Styles";
import AddCrossTinyIcon from "../../Icons/collection/AddCrossTiny";

export interface IGlobalAddButton
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Disabled prop */
  disabled?: boolean;
  /** CSS classes */
  className?: string;
}

export const GlobalAddButton = forwardRef<HTMLButtonElement, IGlobalAddButton>(
  ({ className, disabled = false, ...rest }, ref) => {
    return (
      <StyledGlobalAddButton
        ref={ref}
        variant="contained"
        disabled={disabled}
        className={classnames("c-global-add-btn", className)}
        {...rest}
      >
        <AddCrossTinyIcon />
      </StyledGlobalAddButton>
    );
  }
);

GlobalAddButton.displayName = "GlobalAddButton";
